module.exports = { 
    is_auth :  require('./is_auth').is_auth,
    user_registro :  require('./user_registro').user_registro
}